import React, { useEffect, useState, useContext } from 'react';
import ContactUsForm from '/src/Components/ContactUsForm/ContactUsForm';
import { changePageTitle } from '/src/services/GoogleAnalytics/ChangePageTitle';
import { AddressSearchContext, WindowSizeContext } from '/src/App';
import HelmetProvider from '/src/Components/HelmetProvider/HelmetProvider';
import './style.css';

const ContactUs = ({ type = "contact-us" }) => {
    const [title, setTitle] = useState("");
    const [pageTitle, setPageTitle] = useState(null);
    const [introText, setIntroText] = useState(null);

    const { handleChangePageTitle } = useContext(AddressSearchContext);

    useEffect(() => {
        if (type === "contact-us") {
            setTitle("Get In Touch");
            setPageTitle("Contact Us");
            setIntroText(null);
        } else if (type === "ccpa-data-request") {
            setTitle("CCPA Data Request");
            setPageTitle("CCPA Data Request");
            const intro = `If you are a California resident, you have rights under the California Consumer Privacy Act (CCPA) regarding how we handle your data. Details can be found in our <a href="/privacy/privacy-policy">Privacy Policy</a>.<br/><br/>Please complete all of the fields in the CA Residents Personal Data Request form to the left to begin the validation process for your request. Each request that meets the criteria stated in our <a href="/privacy/privacy-policy">Privacy Policy</a> will be considered a “Valid Request.” We will only use Personal Data provided in a Valid Request to verify your identity and complete your request. We will work to respond to your Valid Request within 45 days of receipt. We may not respond to requests that do not meet these criteria.<br/><br/>If you have any questions about how we comply with the CCPA or whether any of the following rights that apply to you as a CA resident, please contact us at <a href="mailto:privacy@quollintelligence.com">privacy@quollintelligence.com</a>.`
            setIntroText(intro)
        } else if (type === "do-not-sell") {
            setTitle("Do Not Sell My Personal Information");
            setPageTitle("Do Not Sell My Personal Information");
            const intro = `As we’ve described in the “Tracking Tools, Advertising and Opt-Out” section in our <a href="/privacy/privacy-policy">Privacy Policy</a>, we have incorporated Cookies from certain third parties into our Services to help our site run smoothly. These Cookies allow those third parties to receive information about your activity on our services that is associated with your browser or device. Those third parties may use that data to serve you relevant ads on our Services or on other websites you visit. We use the term ‘sell’ as it is defined in the California Consumer Privacy Act (the “CCPA”). Under the CCPA, sharing your data through third party Cookies for online advertising may be considered a “sale” of information. You can opt out of these sales by completing the form below.`
            setIntroText(intro)
        }
    }, [type]);

    // useEffect(() => {
    //     // console.log('pageTitle', pageTitle)
    //     if (pageTitle) {
    //         handleChangePageTitle(pageTitle);
    //     }
    // }, [pageTitle]);

    return (
        <>
            {pageTitle &&
                <HelmetProvider
                pageType="contact"
                customTitle={pageTitle}
                />
            }
            <div className="static-page-content-frame">
                <h1>{title}</h1>
                {introText && <p className="contact-us-intro-text" dangerouslySetInnerHTML={{ __html: introText }} />}
                <ContactUsForm type={type} />
            </div>
        </>
    );
};

export default ContactUs;